export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
  "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
  "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand",
  "West Bengal", "Delhi", "Jammu & Kashmir", "Ladakh", "Puducherry",
  "Chandigarh", "Andaman & Nicobar", "Dadra & Nagar Haveli", "Lakshadweep",
];

export const CATEGORIES = [
  { value: "project", label: "Renewable Projects", description: "Operational / under-construction RE projects" },
  { value: "land", label: "Land Parcels", description: "Land suitable for solar, wind or hybrid parks" },
  { value: "connectivity", label: "Connectivity (CTU/STU)", description: "Grid connectivity and bay allocations" },
  { value: "power", label: "Short-term RE Power", description: "State-wise short-term renewable power" },
];

export const TECHNOLOGIES = [
  { value: "solar", label: "Solar" },
  { value: "wind", label: "Wind" },
  { value: "hybrid", label: "Hybrid" },
  { value: "hydro", label: "Hydro" },
  { value: "other", label: "Other" },
];

export const LISTING_TYPES = [
  { value: "sell", label: "Offering / Sell" },
  { value: "buy", label: "Requirement / Buy" },
];

export const PRICE_UNITS = [
  { value: "lumpsum", label: "Lumpsum (INR)" },
  { value: "per_mw", label: "INR / MW" },
  { value: "per_kwh", label: "INR / kWh" },
  { value: "per_acre", label: "INR / Acre" },
];

export const CONNECTIVITY_TYPES = ["CTU", "STU"];
